import React, { useEffect, useState } from 'react'
import { approvePurchaseOrderApi, getPurchaseOrderApi, getUserSiteDashboardApi } from '../../utils/ApiEndpointFunctions';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { MONTHS } from '../../utils/constant';
import Spinwheel from '../../components/common/Spinwheel';
import { useUserContext } from '../../context/userContext';
import toast from 'react-hot-toast';
import ConfirmationModal from '../../components/modal/ConfirmationModal';
import PurchaseTable from '../purchageOrder/PurchaseTable';
import Challan from '../challan/Challan';
import Voucher from '../voucher/Voucher';
import Cashbook from '../cashbook/cashbook';
import DashboardView from './DashboardView';

function Dashboard() {
  const [selectedTab, setSelectedTab] = useState("purchase")
  const navigate = useNavigate();
  const { userDetails,langPreference } = useUserContext();
  const [searchParams, setSearchParams] = useSearchParams();
  const [timeZone, setTimeZone] = useState('all'); // default value
  const [details,setDetails] = useState(null)
  const [loading,setLoading] = useState(true)


    const getDashboardDetails = async (value) => {
        setLoading(true)
        try {
           const res = await getUserSiteDashboardApi(value)
           if (res.status === 200) {
              setDetails(res.data?.data?.[0]);
           }  
        } catch (err) {
           console.log(err)
           if (err.response && err.response.data) {
              toast.error(err.response.data.message)
            } else {
              toast.error("Something went wrong") 
      
            }
        } finally {
           setLoading(false)
        }
     }

  const handleChange = (e) => {
    setTimeZone(e.target.value);
    getDashboardDetails(e.target.value)
  };

    useEffect(() => {
        getDashboardDetails("all")
    }, [])
  // console.log()
  return (
    <>
      <div className="dash-table">
      <div className='container-fluid'>
        <div className="d-flex justify-content-end mb-2">
          <select
            className="form-select"
            style={{ width: "180px" }}
            value={timeZone}
            onChange={handleChange}
          >
            <option value="all">All Time</option>
            <option value="currentMonth">Current Month</option>
          </select>
        </div>
      </div>
    </div>
    {userDetails?.roleId?.permission.includes("siteProgressReport") || true ? <DashboardView details={details} loading={loading}/>
        : userDetails && Object.keys(userDetails).length === 0 && userDetails.constructor === Object ? <div className="d-flex justify-content-center align-items-center vh-100">
          <Spinwheel />
      </div>: <>
     <div className="dash-nav1">
        <div className="d-flex justify-content-between align-items-center">
          <h3 className="mb-0 font-blue">{langPreference?.dashboard || "Dashboard"}</h3>
          {userDetails?.roleId?.permission?.includes("poWrite") && (searchParams.get("tab") == "purchase" || searchParams.get("tab") == null) && <button onClick={() => { navigate("/purchase/add"); }} className="create-order">{langPreference?.create_po || "Create Purchase Order"}</button>}
        </div>  
      </div>
      <div className="dash-table">
        <ul className="nav nav-tabs" id="myTab" role="tablist">
          <li className="nav-item" role="presentation">
            <button onClick={() => setSearchParams({ tab: 'purchase' })} className={`nav-link ${(searchParams.get("tab") == "purchase" || searchParams.get("tab") == null) && "active"}`} >{langPreference?.purchase_order || "Purchase order"}</button>
          </li>
          <li className="nav-item" role="presentation">
            <button onClick={() => setSearchParams({ tab: 'challan' })} className={`nav-link ${searchParams.get("tab") == "challan" && "active"}`} >{langPreference?.challan || "Challan"}</button>
          </li>
          <li className="nav-item" role="presentation">
            <button onClick={() => setSearchParams({ tab: 'voucher' })} className={`nav-link ${searchParams.get("tab") == "voucher" && "active"}`} >{langPreference?.voucher ||"Voucher"}</button>
          </li>
          {userDetails?.roleId?.permission?.includes("cashbookRead") &&  <li className="nav-item" role="presentation">
            <button onClick={() => setSearchParams({ tab: 'cashbook' })} className={`nav-link ${searchParams.get("tab") == "cashbook" && "active"}`} >{langPreference?.my_cashbook || "My Cashbook"}</button>
          </li> }
        </ul>
        <div className="tab-content" id="myTabContent">
          <div className={`tab-pane fade ${(searchParams.get("tab") == "purchase" || searchParams.get("tab") == null) && "show active"} `} id="home-tab-pane" role="tabpanel" aria-labelledby="home-tab" tabIndex="0">
            <PurchaseTable type="dashboard" />
          </div>
          <div className={`tab-pane fade ${searchParams.get("tab") == "challan" && "show active"} `} >{searchParams.get("tab") == "challan" && <Challan type="dashboard" />}</div>
          <div className={`tab-pane fade ${searchParams.get("tab") == "voucher" && "show active"} `} >{searchParams.get("tab") == "voucher" && <Voucher type="dashboard" />}</div>
          <div className={`tab-pane fade ${searchParams.get("tab") == "cashbook" && "show active"} `}>{searchParams.get("tab") == "cashbook" && <Cashbook type="dashboard"/>}</div>
        </div>
      </div>
    </> 
     }
    
    </>
  )
}

export default Dashboard
